import axios from "axios";

const host = process.env.REACT_APP_API_HOST || (process.env.NODE_ENV === "development" ? "http://localhost:63362" : window.location.origin);
const modeClient = axios.create();
let snapshot = null;
let loading = null;
let lastError = null;
let retryAfter = 0;
export const modeEndpoint = `${host}/api/QrWorkflowMode`;
export function getQrMode() {
  if (snapshot) return Promise.resolve(snapshot);
  if (lastError && Date.now() < retryAfter) return Promise.reject(lastError);
  if (!loading) loading = modeClient.get(modeEndpoint).then(response => {
    snapshot = response.data;
    lastError = null;
    retryAfter = 0;
    window.dispatchEvent(new CustomEvent("qr-mode-ready", { detail: snapshot }));
    return snapshot;
  }).catch(error => {
    lastError = error;
    retryAfter = Date.now() + 15000;
    throw error;
  }).finally(() => { loading = null; });
  return loading;
}
export async function checkQrMode() {
  const next = (await modeClient.get(modeEndpoint)).data;
  if (snapshot && (snapshot.revision !== next.revision || snapshot.environment !== next.environment || snapshot.dataMode !== next.dataMode)) {
    // Keep the old request revision until navigation cancels all old component work,
    // including paginated exports and asynchronous form continuations.
    window.location.reload();
    return snapshot;
  }
  if (!snapshot) { snapshot = next; window.dispatchEvent(new CustomEvent("qr-mode-ready", { detail: next })); }
  return snapshot;
}
export async function changeQrMode(mode, target) {
  await modeClient.put(modeEndpoint, { dataMode: target, expectedRevision: mode.revision, confirmed: true }, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
  });
  window.location.reload();
}
export function isQrRequest(url) {
  return /\/api\/(DriverWorkflow(?:\/|$)|ChecklistManagement(?:\/|$)|ChecklistNotifications(?:\/|$)|Report\/(?:Replay|ChecklistRuns|IncidentReports|DriverLogShiftSummary)(?:\/|$)|DriverIncidents\/Recent|Assets\/.*(?:Driver|CriticalChecklist|QrToken))/i.test(url || "");
}
export function installQrModeInterceptor(client) {
  client.interceptors.request.use(async config => {
    if (!isQrRequest(config.url)) return config;
    const mode = await getQrMode();
    config.headers = { ...config.headers, "X-QR-Mode-Revision": String(mode.revision), "X-QR-Environment": mode.environment };
    // Legacy report clients supply this parameter. Its value now comes only from
    // the server snapshot; the server still independently rejects conflicting targets.
    if (config.params && Object.prototype.hasOwnProperty.call(config.params, "test")) config.params = { ...config.params, test: mode.testMode };
    return config;
  });
  client.interceptors.response.use(response => response, error => {
    if (error.response?.data?.code === "qr_mode_changed") checkQrMode().catch(() => {});
    return Promise.reject(error);
  });
}
installQrModeInterceptor(axios);
